<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-mermaid">
      <div class="px-3 col-3 p-0">
        <div class="heading-mermaid">{{ $t('result.round') }}</div>
        <div class="text-subhead-mermaid">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mermaid">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-mermaid">{{ data.bet | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mermaid">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-mermaid">{{ data.winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-mermaid">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-mermaid">{{ data.balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-mermaid pt-3">
      <div class="text-games-mermaid">{{ 'Mermaid Market' }}</div>
      <div class="text-subgame-mermaid">{{ $t('mermaid.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 100px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white;">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-mermaid" @click="delCount()"></i>
        </div>
        <div class="wheel-wrapper multiplier-wrapper">
          <img v-if="isFreespin" class="multiplier-image" width="100%"
            :src="require(`../../assets/resultGame/mermaid/freespin${mode}_multiplier${multiplier}.png`)" alt="">
          <img v-else class="multiplier-image" width="100%"
            :src="require(`../../assets/resultGame/mermaid/multiplier${multiplier}_normal.png`)" alt="">
        </div>
        <div class="table-mermaid d-flex flex-column justify-content-center">
          <table class="table-pos">
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="i">
                  <img class="icon-symbol-mermaid" :src="require(`../../assets/resultGame/mermaid/symbol_${col}.png`)"
                    alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!data.detail.isEndRound" class="fas fa-caret-right arrow-side-mermaid" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-mermaid">
        <h1 v-if="isFreespin">FREESPIN {{ data.detail.round }}/{{ data.detail.page }}</h1>
        <h1 v-else>SPIN {{ data.detail.round }}/{{ data.detail.page }}</h1>
      </div>
      <div v-if="data.detail.winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-mermaid">Feature Buy</div>
      <div v-if="data.detail.winnings.length" class="col-12 justify-content-center d-flex flex-row">
        <div class="bet-box-mermaid p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in data.detail.winnings" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-mermaid item">
                <div class="d-flex justify-content-start bet-wrapper-mermaid item">
                  <img class="icon-detail-mermaid"
                    :src="require(`../../assets/resultGame/mermaid/symbol_${detail.symbol}.png`)" alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{ `${detail.count} ` + $t('result.kind') }}</p>
                    <p>Line {{ `${detail.line + 1} ` }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ detail.amount | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-mermaid',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 5, 8, 12, 16,],
        [2, 6, 9, 13, 17,],
        [3, 7, 10, 14, 18,],
        [4, 8, 11, 15, 19,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      isRespin: false,
      multiplier: 0,
      mode: 0
    }
  },
  async created() {
    await this.mapSymbol()
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-mermaid')[0].offsetHeight
    },
    mapSymbol() {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = this.data.detail.multiplier
      this.isFreespin = (this.data.detail.state === 'FREESPIN' || this.data.detail.state === 'FREERESPIN')
      this.isRespin = this.data.detail.state === 'RESPIN'
      this.mode = this.data.detail.freeSpin ? this.data.detail.freeSpin.mode : 0;

      if (this.table.length <= 3) {
        this.table.push(this.table[0])
      }

      this.table[0][0] = this.data.detail.nextReel[0][0]
      this.table[1][0] = this.data.detail.reels[0][0]
      this.table[2][0] = this.data.detail.reels[0][1]
      this.table[3][0] = this.data.detail.reels[0][2]
      this.table[0][1] = this.data.detail.nextReel[1][0]
      this.table[1][1] = this.data.detail.reels[1][0]
      this.table[2][1] = this.data.detail.reels[1][1]
      this.table[3][1] = this.data.detail.reels[1][2]
      this.table[0][2] = this.data.detail.nextReel[2][0]
      this.table[1][2] = this.data.detail.reels[2][0]
      this.table[2][2] = this.data.detail.reels[2][1]
      this.table[3][2] = this.data.detail.reels[2][2]
      this.table[0][3] = this.data.detail.nextReel[3][0]
      this.table[1][3] = this.data.detail.reels[3][0]
      this.table[2][3] = this.data.detail.reels[3][1]
      this.table[3][3] = this.data.detail.reels[3][2]
      this.table[0][4] = this.data.detail.nextReel[4][0]
      this.table[1][4] = this.data.detail.reels[4][0]
      this.table[2][4] = this.data.detail.reels[4][1]
      this.table[3][4] = this.data.detail.reels[4][2]

      this.table.shift();

      if (this.data.detail.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      const countData = this.data.count + 1
      this.$emit('fetchResult', countData)
      await this.mapSymbol()
    },
    async delCount() {
      const countData = this.data.count - 1
      this.$emit('fetchResult', countData)
      await this.mapSymbol()
    },
  }
}
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933
    /* margin: 0; */
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-mermaid {
  width: 100px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-mermaid {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-mermaid {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-mermaid {
  background: #0c161f;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box-mermaid {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-mermaid .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box-mermaid .bet-wrapper-mermaid:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-mermaid,
.result-wrapper {
  font-size: 35px;
}

.header-mermaid {
  background: #901AB4;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-mermaid>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-mermaid {
  color: #000000;
  text-align: center;
}

.content-result-mermaid {
  background: #316DD4;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-mermaid {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-mermaid {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-mermaid {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-mermaid {
  font-size: 20px;
  color: #FFD500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #FFF5BF;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-mermaid {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-mermaid {
  min-width: 600px;
  max-width: auto;
}

.table-mermaid {
  background: url('~@/assets/resultGame/mermaid/slotmachine.png') no-repeat;
  z-index: 5;
  background-size: 517px 293px;
  /* set Bg Table HERE */
  width: 517px;
  height: 293px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
}

.table-pos {
  transform: translate(0px, -7px);
}

@media screen and (max-width: 1030px) {
  .table-mermaid {
    background-size: 517px 293px;
    width: 517px;
    height: 293px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }


  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-mermaid {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-mermaid,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-mermaid,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-mermaid {
    font-size: 18px;
  }

  .table-mermaid {
    background-size: 400px 236px;
    width: 400px;
    height: 236px;
    margin-bottom: 1%;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-mermaid {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-mermaid {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }


  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-mermaid>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-mermaid {
    font-size: 12px;
  }

  .table-mermaid {
    background-size: 250px 180px;
    width: 250px;
    height: 180px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-mermaid {
    font-size: 14px;
  }

  .bet-box-mermaid {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-mermaid {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-mermaid,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-mermaid {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-mermaid {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }
}
</style>